import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
  Button, Header, Message,
} from 'semantic-ui-react';
import { endSession } from '../modules/session';

import CenterCard from './center_card';
import ErrorType from './types/error_type';

class SignedinConfirmation extends Component {
  handleConfirmSignout = (e) => {
    const { connectedEndSession } = this.props;
    e.preventDefault();

    connectedEndSession({ reload: true });
  }

  go = (e, pathname) => {
    e.preventDefault();
    window.location.pathname = pathname;
  }

  renderErrorMessage = () => (
    <Message error>
      Something went wrong. Please try again or contact
      <a href="mailto:support@remeeting.com"> support</a>
    </Message>
  );

  render() {
    const {
      error, routeName, routeActionDescription, sessionEmail, signOutRequestOut,
    } = this.props;
    return (
      <CenterCard routeName={routeName}>
        <Header>
          {`You are currently signed in as: ${sessionEmail}`}
        </Header>
        <p>
          { `Do you wish to sign out, and then ${routeActionDescription}?` }
        </p>
        <div className="re is-flex is-flex-row is-flex-justify-space-between is-marginTop-16px is-flex-align-center">
          <Button
            loading={signOutRequestOut}
            onClick={this.handleConfirmSignout}
            primary
          >
            Sign out
          </Button>
          <a href="/app/account">View my account</a>
        </div>
        { error && error.statusCode !== 401 && this.renderErrorMessage() }
      </CenterCard>
    );
  }
}

SignedinConfirmation.propTypes = {
  error: ErrorType,
  routeName: PropTypes.string.isRequired,
  routeActionDescription: PropTypes.string.isRequired,
  sessionEmail: PropTypes.string.isRequired,
  signOutRequestOut: PropTypes.bool.isRequired,
  connectedEndSession: PropTypes.func.isRequired,
};

SignedinConfirmation.defaultProps = {
  error: undefined,
};

const mapStateToProps = (state) => ({
  error: state.session.error,
  sessionEmail: state.session.email,
  signOutRequestOut: state.session.signOutRequestOut,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  connectedEndSession: endSession,
}, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(SignedinConfirmation);
